import setSiteMeta from '../base-saving-actions/set-site-meta';

const updateFolders = (folders) =>
  folders.reduce(
    (saveActions, folder) => [...saveActions, setSiteMeta(['folders', folder.id], folder)],
    []
  );

export default updateFolders;
